






















import { Vue, Component, Prop } from 'vue-property-decorator'
import { dateFormat } from '@/utils/baseFn'
@Component
export default class DownloadDialog extends Vue {
  @Prop() dialogVisible!: boolean;
  dateRange = [];

  downloadParams () {
    const { dateRange } = this
    return `startDate=${dateFormat(
      dateRange[0],
      'YYYY-MM-DD'
    )}&endDate=${dateFormat(
      dateRange[1],
      'YYYY-MM-DD'
    )}&tenantIdParam=1001&access_token=${
      sessionStorage.getItem('token') || ''
    }`
  }

  downloadRule () {
    const { dateRange } = this
    if (dateRange[0] && dateRange[1]) {
      return true
    } else {
      this.$message({
        type: 'error',
        message: '请先选择下载日期',
      })
      return false
    }
  }

  openNewWindow (path: string) {
    let _origin = location.origin
    if (process.env.NODE_ENV === 'development') {
      _origin = 'https://wm-test310.newtamp.cn'
    }
    window.open(
      _origin +
        '/aap/api/v1/blackcat/audit/' +
        path +
        '?' +
        this.downloadParams(),
      '_blank'
    )
  }

  async handleDownload (path: string) {
    if (this.downloadRule()) {
      this.openNewWindow(path)
      this.handleClose()
    }
  }

  handleClose () {
    this.$emit('on-close', true)
  }
}
